import { Navigate } from "react-router-dom";
import ShowQuestions from "layouts/quizTitles/ShowQuestions.js";
import PresentationTitles from "../prof/presentationTitles";
import PresentationMakerPage from "../prof/presentationTitles/PresentationMakerPage";
import ProfStats from "../prof/ProfStats";
import QuizSystem from "../prof/QuizSystem";
import HeatMap from "../prof/HeatMap";
import QuizResults from "../prof/QuizResults";
import QuizInsights from "../prof/QuizInsights";
import Titles from "../layouts/titles";
import ShowTile from "../layouts/titles/ShowTile";
import ShowThreeD from "../layouts/titles/ShowThreeD";

import Icon from "@mui/material/Icon";
import Professors from "../layouts/professors";
import Students from "../layouts/students";

const universityRoutes = [
  {
    route: "/dashboard",
    key: "dashboardRedirect",
    component: <Navigate to="/stats" replace />,
  },
  {
    type: "collapse",
    name: "Stats",
    key: "stats",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/stats",
    component: <ProfStats />,
  },
  {
    type: "collapse",
    name: "Quiz Insights",
    key: "quiz-insights",
    icon: <Icon fontSize="small">psychology</Icon>,
    route: "/quiz/insights",
    component: <QuizInsights />,
  },
  {
    type: "collapse",
    name: "Professors",
    key: "professors",
    icon: <Icon fontSize="small">school</Icon>,
    route: "/professors",
    component: <Professors />,
  },
  {
    type: "collapse",
    name: "Students",
    key: "students",
    icon: <Icon fontSize="small">groups</Icon>,
    route: "/students",
    component: <Students />,
  },
  {
    type: "collapse",
    name: "3D Models",
    key: "threeDTitles",
    icon: <Icon fontSize="small">view_in_ar</Icon>,
    route: "/threeDTitles",
    component: <Titles type="three_d_model" readOnly />,
  },
  {
    type: "collapse",
    name: "Histology",
    key: "titles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/titles",
    component: <Titles type="his" readOnly />,
  },
  {
    type: "collapse",
    name: "Embryology",
    key: "embryologyTitles",
    icon: <Icon fontSize="small">image</Icon>,
    route: "/embryologyTitles",
    component: <Titles type="emb" readOnly />,
  },
  {
    type: "collapse",
    name: "Quiz",
    key: "quiz",
    icon: <Icon fontSize="small">quiz</Icon>,
    collapse: [
      {
        type: "collapse",
        name: "My Titles",
        key: "quiz-titles",
        route: "/quiz/titles",
        component: <QuizSystem stage={0} />,
      },
      {
        type: "collapse",
        name: "Question Bank",
        key: "quiz-questions",
        route: "/quiz/questions",
        component: <QuizSystem stage={1} />,
      },
      {
        type: "collapse",
        name: "Create Quiz",
        key: "quiz-create",
        route: "/quiz/create",
        component: <QuizSystem stage={2} />,
      },
      {
        type: "collapse",
        name: "Heat map",
        key: "quiz-heatmap",
        route: "/quiz/heatmap",
        component: <HeatMap />,
      },
      {
        type: "collapse",
        name: "Results",
        key: "quiz-results",
        route: "/quiz/results",
        component: <QuizResults />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Presentations",
    key: "presentationTitles",
    icon: <Icon fontSize="small">tv</Icon>,
    route: "/presentationTitles",
    component: <PresentationTitles />,
  },
  {
    name: "presentationMakerPage",
    key: "presentationMakerPage",
    route: "/presentationMakerPage/:id",
    component: <PresentationMakerPage />,
  },
  {
    name: "showTitle",
    key: "showTitle",
    route: "/showTitle/:id/:lang",
    component: <ShowTile />,
  },
  {
    name: "showThreeD",
    key: "showThreeD",
    route: "/showThreeD/:id/:lang",
    component: <ShowThreeD />,
  },
  {
    name: "showQuestions",
    key: "showQuestions",
    route: "/showQuestions/:id/:lang",
    component: <ShowQuestions />,
  },
];

export default universityRoutes;
